import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { format } from 'date-fns';

import { MultiAutocomplete } from '~/components/Form';
import { Select } from '~/components/Form/v2';
import { t } from '~/helpers';

import { tipoabastecimento, tipoVeiculo } from '../../utils/constants';
import * as S from './styles';

export default function Filters({ params, setParams }) {
  const { language } = useSelector((state) => state.user);

  const output = useMemo(() => {
    if (language === 'pt-BR') {
      return 'DD/MM/YYYY HH:mm:ss';
    }

    return 'YYYY-MM-DD HH:mm:ss';
  }, [language]);

  const optionsAfericao = useMemo(
    () => [
      { value: '1', label: t('Dia') },
      { value: '2', label: t('Semana') },
      { value: '3', label: t('Mes') },
      { value: '4', label: t('Ano') },
    ],
    []
  );

  const handleDateInicialChange = useCallback((data) => {
    setParams((prevState) => ({
      ...prevState,
      datahorainicialmovimentacao: data.format('YYYY-MM-DD HH:mm:ss'),
    }));
  }, []);
  const handleDateFinalChange = useCallback((data) => {
    setParams((prevState) => ({
      ...prevState,
      datahorafinalmovimentacao: data.format('YYYY-MM-DD HH:mm:ss'),
    }));
  }, []);

  return (
    <S.DatePickerWrapper>
      <Select
        name="idagrupamento"
        label={t('Agrupamento')}
        data={optionsAfericao}
        defaultValue={params.idagrupamento}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            idagrupamento: value.value,
          }))
        }
        minWidth={180}
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            idposto: value.map((posto) => posto.idposto),
          }))
        }
      />

      <MultiAutocomplete
        multiple
        name="idempresaveiculo"
        label="nomeempresaveiculo"
        url="empresasveiculos"
        unique="idempresaveiculo"
        title={t('s.menu.cadastro.veiculo.empresa')}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            idempresaveiculo: value.map(
              (posto) => `'${posto.idempresaveiculo}'`
            ),
          }))
        }
        params={{
          orderfield: 'nomeempresaveiculo',
          ordination: 'asc',
          pesquisalista: true,
        }}
      />
      <MultiAutocomplete
        multiple
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            idproduto: value.map((posto) => posto.idproduto),
          }))
        }
        params={{
          wherefield: 'tipoproduto',
          valuewherefield: 'C',
          typewherefield: 'EQUALS',
        }}
      />
      <MultiAutocomplete
        multiple
        name="value"
        label="label"
        url="as"
        unique="value"
        options={tipoabastecimento}
        title={t('Contingencia')}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            contingenciamovimentacaoabastecimento: value.map(
              (posto) => posto.value
            ),
          }))
        }
      />
      <MultiAutocomplete
        multiple
        name="value"
        label="label"
        url="as"
        unique="value"
        options={tipoVeiculo}
        title={t('Tipo Veiculo')}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            tipoveiculo: value.map((posto) => posto.value),
          }))
        }
      />
      <S.DatePicker
        name="inicial"
        ampm={language !== 'pt-BR'}
        size="small"
        inputVariant="outlined"
        cancelLabel={t('s.geral.botaocancelar')}
        format={output}
        onChange={handleDateInicialChange}
        value={params.datahorainicialmovimentacao}
        maxDate={params.datahorafinalmovimentacao}
        KeyboardButtonProps={{ padding: 0 }}
      />
      <S.DatePicker
        size="small"
        ampm={language !== 'pt-BR'}
        inputVariant="outlined"
        cancelLabel={t('s.geral.botaocancelar')}
        format={output}
        onChange={handleDateFinalChange}
        value={params.datahorafinalmovimentacao}
        maxDate={format(new Date(), 'yyyy-MM-dd 00:00:00')}
        KeyboardButtonProps={{ padding: 0 }}
      />
    </S.DatePickerWrapper>
  );
}
